module.exports = __webpack_public_path__ + "static/playstore-en-8c52965aae57bd6d210ad46c57fb9b2a.png";